import { cropRatioValue } from './types';

export const UNSET_RATIO: cropRatioValue = {
  shape: 'square',
  horizontal: undefined,
  vertical: undefined,
};
export const UNSET_SIZE_VALUES = {
  width: 0,
  height: 0,
};
export const UNSET_AXIS_VALUES = {
  x: 0,
  y: 0,
};
export const UNSET_MAX_VALUES = {
  maxWidth: 0,
  maxHeight: 0,
};
